import { SET_APP_HOME_CONFIG } from './ApphomeTypes';

const initialState = {
  apphome: {},
};

export default (state = initialState, action = {}) => {
  // console.log("STATE",action)
  switch (action.type) {
    case SET_APP_HOME_CONFIG:
      return {
        ...state,
        apphome: action.payload,
      };
    default:
      return state;
  }
};
